import { Link } from 'react-router-dom';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}
      <header className="border-b border-zinc-900">
        <div className="max-w-7xl mx-auto px-6 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity cursor-pointer">
            <i className="ri-arrow-left-line text-2xl text-red-500 w-6 h-6 flex items-center justify-center"></i>
            <span className="text-white font-bold text-lg tracking-wider">BACK TO HOME</span>
          </Link>
          
          <img 
            src="https://static.readdy.ai/image/f2e9d0ecb0c8da9b7a5f1d855b73822d/053272dcaa033b9b5356f9612e504e77.png"
            alt="E.T.C Logo"
            className="h-12 w-auto"
          />
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-6 py-12 md:py-20">
        <h1 className="text-5xl md:text-6xl font-black text-white mb-6 uppercase tracking-tight">
          Privacy Policy
        </h1>
        
        <p className="text-gray-400 text-sm mb-12">
          Last Updated: January 2025
        </p>

        <div className="space-y-8 text-gray-300 leading-relaxed">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide">1. Introduction</h2>
            <p>
              Welcome to E.T.C. ("we," "our," or "us"). We respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website ericmoore.online and participate in our giveaways and promotions.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide">2. Information We Collect</h2>
            <p className="mb-4">We may collect the following types of information:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong className="text-white">Personal Information:</strong> Name, email address, phone number, and mailing address when you subscribe to our newsletter or enter giveaways.</li>
              <li><strong className="text-white">Usage Data:</strong> Information about how you access and use our website, including your IP address, browser type, pages visited, and time spent on pages.</li>
              <li><strong className="text-white">Cookies and Tracking:</strong> We use cookies and similar tracking technologies to enhance your experience and analyze website traffic.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide">3. How We Use Your Information</h2>
            <p className="mb-4">We use the information we collect to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Process and manage giveaway entries and prize fulfillment</li>
              <li>Send newsletters, updates, and promotional materials</li>
              <li>Respond to inquiries and provide customer support</li>
              <li>Improve our website and user experience</li>
              <li>Comply with legal obligations and enforce our terms</li>
              <li>Analyze website traffic and user behavior</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide">4. Information Sharing and Disclosure</h2>
            <p className="mb-4">We do not sell your personal information. We may share your information with:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong className="text-white">Service Providers:</strong> Third-party companies that help us operate our website and conduct giveaways (e.g., email service providers, giveaway platforms).</li>
              <li><strong className="text-white">Legal Requirements:</strong> When required by law or to protect our rights and safety.</li>
              <li><strong className="text-white">Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide">5. Data Security</h2>
            <p>
              We implement reasonable security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide">6. Your Rights and Choices</h2>
            <p className="mb-4">You have the right to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Access, update, or delete your personal information</li>
              <li>Opt-out of marketing communications at any time</li>
              <li>Disable cookies through your browser settings</li>
              <li>Request a copy of the information we hold about you</li>
            </ul>
            <p className="mt-4">
              To exercise these rights, please contact us at <a href="mailto:etc333music@gmail.com" className="text-red-500 hover:text-red-400 transition-colors cursor-pointer">etc333music@gmail.com</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide">7. Third-Party Links</h2>
            <p>
              Our website may contain links to third-party websites. We are not responsible for the privacy practices of these external sites. We encourage you to review their privacy policies before providing any personal information.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide">8. Children's Privacy</h2>
            <p>
              Our website is not intended for children under 13 years of age. We do not knowingly collect personal information from children under 13. If you believe we have collected information from a child under 13, please contact us immediately.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide">9. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated "Last Updated" date. We encourage you to review this policy periodically.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide">10. Contact Us</h2>
            <p>
              If you have any questions or concerns about this Privacy Policy, please contact us at:
            </p>
            <p className="mt-4">
              <strong className="text-white">Email:</strong> <a href="mailto:etc333music@gmail.com" className="text-red-500 hover:text-red-400 transition-colors cursor-pointer">etc333music@gmail.com</a>
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-zinc-900 mt-20">
        <div className="max-w-7xl mx-auto px-6 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © 2025 E.T.C. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy-policy" className="text-gray-500 hover:text-red-500 transition-colors text-sm cursor-pointer">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="text-gray-500 hover:text-red-500 transition-colors text-sm cursor-pointer">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
